import React from "react";
import { sketchfabEmbedUrl } from "@/data/weaponSketchfab";

/**
 * Viewer Sketchfab (iframe) para pré-visualização 3D da arma.
 * @param {{ embed: { modelId: string, title: string, credit?: { modelUrl: string, author: string, authorUrl: string } }, active?: boolean }} props
 */
export default function WeaponSketchfabViewer({ embed, active = true }) {
    if (!embed?.modelId) return null;

    const src = sketchfabEmbedUrl(embed.modelId);

    return (
        <div className="vip-sim-sketchfab">
            <div className="vip-sim-sketchfab__frame">
                {active ? (
                    <iframe
                        title={embed.title}
                        src={src}
                        frameBorder="0"
                        allowFullScreen
                        mozAllowFullScreen="true"
                        webkitAllowFullScreen="true"
                        allow="autoplay; fullscreen; xr-spatial-tracking"
                        xr-spatial-tracking="true"
                        execution-while-out-of-viewport="true"
                        execution-while-not-rendered="true"
                        web-share="true"
                        className="vip-sim-sketchfab__iframe"
                    />
                ) : (
                    <div className="vip-sim-sketchfab__placeholder" aria-hidden />
                )}
            </div>
            {embed.credit ? (
                <p className="vip-sim-sketchfab__credit">
                    <a href={embed.credit.modelUrl} target="_blank" rel="noopener noreferrer">
                        {embed.title}
                    </a>
                    {" by "}
                    <a href={embed.credit.authorUrl} target="_blank" rel="noopener noreferrer">
                        {embed.credit.author}
                    </a>
                    {" on "}
                    <a href="https://sketchfab.com" target="_blank" rel="noopener noreferrer">
                        Sketchfab
                    </a>
                </p>
            ) : null}
        </div>
    );
}
